package com.schoolconnect.app.feature.teachers

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember

@Composable
fun TeachersFeatureRoute(
    onBack: () -> Unit,
    schoolId: String = ""
) {
    val viewModel = remember(schoolId) { TeachersViewModel(schoolId) }
    val uiState by viewModel.uiState.collectAsState()

    DisposableEffect(viewModel) {
        onDispose { viewModel.clear() }
    }

    TeachersScreen(
        state = uiState,
        onEvent = viewModel::onEvent,
        onBack = onBack
    )
}
